import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LoaderComponent implements OnInit {

  loaded = false;

  @Input('loaded')
  set _loaded(_loaded:boolean){
    this.loaded = _loaded;
  }

  constructor() {};

  ngOnInit(): void {};

}
